import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import styles from 'feature/login-flow/index.module.sass';
import Button from 'components/button';
import OnBoardingLayout from 'layout/onboarding';
import hint from 'assets/icon_hint.svg';
import logo from 'assets/logo_cpc.png';
import { useLoginFlowContext } from 'feature/login-flow/use-login-flow';
import amplitude from 'service/amplitude';
import { PATH } from 'config';

const BindCpcPayCardPage = () => {
  const { state, bindCpcPayCard } = useLoginFlowContext();
  const history = useHistory();

  useEffect(() => {
    amplitude.bindCard_pageview();
  }, []);

  const onPass = () => {
    amplitude.bindCard_later_onClick();
    history.replace(PATH.MAIN);
  };

  return (
    <OnBoardingLayout className={styles['bind-cpc-pay-card']}>
      <div className={styles.top}>
        <ul className={styles.progress}>
          <li className={styles.active}>1</li>
          <li className={styles.active}>2</li>
          <li className={styles.active}>3</li>
        </ul>
        <div className={styles.card}>
          <img src={logo} alt="cpc-logo" />
        </div>
        <div className={styles.title}>
          連結中油 Pay
          <br />
          信用卡/簽帳金融卡
        </div>
        <div className={styles.desc}>立即開始享受路邊停車自動繳的便利，停車場也能馬上體驗麻吉付！</div>
        <div className={`${styles.hint} ${styles['with-icon']}`}>
          <img src={hint} alt="hint" />
          連結過程將產生一筆台幣 1 元的過卡交易，不會實際請款。
        </div>
      </div>
      <div className={styles.bottom}>
        <Button theme="blue" block={true} loading={state.loading} onClick={bindCpcPayCard}>
          確認連結
        </Button>
        {state.bindCardFailed && (
          <Button theme="link" block={true} onClick={onPass}>
            稍後
          </Button>
        )}
      </div>
    </OnBoardingLayout>
  );
};

export default BindCpcPayCardPage;
